import { render } from "./StartOverlay.vue?vue&type=template&id=162c3e48&scoped=true"
import script from "./StartOverlay.vue?vue&type=script&lang=js"
export * from "./StartOverlay.vue?vue&type=script&lang=js"

import "./StartOverlay.vue?vue&type=style&index=0&id=162c3e48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162c3e48"]])

export default __exports__